import { Col, ConfigProvider, Divider, Flex, Row, Typography } from 'antd';
import { formatDateTime } from '../../../utilities/commonFunctions';
import { HYPHEN } from '../../../utilities/constants';
import PropTypes from 'prop-types';

const { Text } = Typography;

const TripInfoCard = ({ type, startTime, endTime }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Divider: {
            colorSplit: 'var(--primary-text-color, #FFFFFF)',
          },
        },
      }}
    >
      <Flex vertical gap={8}>
        <Text>{`${type} Trip`}</Text>
        <Row className="trip-info-card" align="middle" gutter={[0, 12]}>
          <Col xs={24} md={11}>
            <Flex gap={4} vertical>
              <Text style={{ fontSize: 12 }}>Trip start</Text>
              <Text strong>
                {startTime ? formatDateTime(startTime) : HYPHEN}
              </Text>
            </Flex>
          </Col>
          <Col xs={24} md={2} justify="center" align="middle">
            <Divider type="vertical" style={{ height: 26 }} />
          </Col>
          <Col xs={24} md={11}>
            <Flex gap={4} vertical>
              <Text style={{ fontSize: 12 }}>Trip end</Text>
              <Text strong>{endTime ? formatDateTime(endTime) : HYPHEN}</Text>
            </Flex>
          </Col>
        </Row>
      </Flex>
    </ConfigProvider>
  );
};

TripInfoCard.propTypes = {
  type: PropTypes.string,
  startTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  endTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TripInfoCard;
